<template>
  <v-layout row wrap>
    <v-flex
      md6
      pa-2
      sm12
      xl4
      xs12
    >
      <v-card>
        <v-form
          lazy-validation
          ref="form"
          v-model="valid"
        >
          <v-toolbar>
            <v-toolbar-title>{{label}} {{prototypeValue.name}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              :counter="100"
              :rules="nameRules"
              label="Name"
              required
              v-model="prototypeValue.name"
            ></v-text-field>
            <v-text-field
              :rules="startRules"
              label="Start"
              required
              v-model="prototypeValue.start"
              type="date"
              format="YYYY-MM-DD"
            ></v-text-field>
            <v-text-field
              :rules="endRules"
              label="End"
              required
              v-model="prototypeValue.end"
              type="date"
              format="YYYY-MM-DD"
            ></v-text-field>
            <v-checkbox
              v-if="activeSprint === undefined || activeSprint.id === prototypeValue.id"
              v-model="prototypeValue.active"
              label="Active"
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="!valid"
              @click="submit"
              color="success"
            >
              Save
            </v-btn>
            <v-btn
              @click="reset"
              color="error"
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>

export default {
  name: 'SprintEditFields',
  props: ['value', 'type'],
  data: () => ({
    valid: true,
    prototypeValue: {},
  }),
  computed: {
    label: {
      get() {
        return this.type.charAt(0)
          .toUpperCase() + this.type.slice(1);
      },
    },
    activeSprint() {
      return this.$store.getters.getActiveSprint;
    },
    nameRules() {
      return [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 100 characters',
      ];
    },
    startRules() {
      return [
        v => !!v || 'Start is required',
        v => (v <= this.prototypeValue.end) || 'Start should be before end',
      ];
    },
    endRules() {
      return [
        v => !!v || 'End is required',
      ];
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('input', this.prototypeValue);
      }
    },
    reset() {
      this.initForm();
    },
    initForm() {
      this.prototypeValue = this.value;
    },
  },
  mounted() {
    this.initForm();
  },
};
</script>
